import CategorySelect from "./components/categorySelect";

(function () {

    const sampleResults = `

                <div class="card grid__1-1 grid__1-2--sm grid__1-3--md">
	<div class="card__imageWrapper">
		<img class="card__image lazy loaded" alt="Orawa Dzieciom Afryki" data-ll-status="loaded" src="/wp-content/themes/nswm/assets/test/orawa.jpg">
	</div>
	<!--<h3 class="card__title text--center">actions.js Orawa Dzieciom Afryki</h3>-->
	<a href="#" class="button card__button">Dowiedz się więcej</a>
</div>
<div class="card grid__1-1 grid__1-2--sm grid__1-3--md">
	<div class="card__imageWrapper">
		<img class="card__image lazy loaded" alt="Orawa Dzieciom Afryki" data-ll-status="loaded" src="/wp-content/themes/nswm/assets/test/orawa.jpg">
	</div>
	<!--<h3 class="card__title text--center">Orawa Dzieciom Afryki</h3>-->
	<a href="#" class="button card__button">Dowiedz się więcej</a>
</div>
<div class="card grid__1-1 grid__1-2--sm grid__1-3--md">
	<div class="card__imageWrapper">
		<img class="card__image lazy loaded" alt="Orawa Dzieciom Afryki" data-ll-status="loaded" src="/wp-content/themes/nswm/assets/test/orawa.jpg">
	</div>
	<!--<h3 class="card__title text--center">Orawa Dzieciom Afryki</h3>-->
	<a href="#" class="button card__button">Dowiedz się więcej</a>
</div>
<div class="card grid__1-1 grid__1-2--sm grid__1-3--md">
	<div class="card__imageWrapper">
		<img class="card__image lazy loaded" alt="Orawa Dzieciom Afryki" data-ll-status="loaded" src="/wp-content/themes/nswm/assets/test/orawa.jpg">
	</div>
	<!--<h3 class="card__title text--center">Orawa Dzieciom Afryki</h3>-->
	<a href="#" class="button card__button">Dowiedz się więcej</a>
</div>
<div class="card grid__1-1 grid__1-2--sm grid__1-3--md">
	<div class="card__imageWrapper">
		<img class="card__image lazy loaded" alt="Orawa Dzieciom Afryki" data-ll-status="loaded" src="/wp-content/themes/nswm/assets/test/orawa.jpg">
	</div>
	<!--<h3 class="card__title text--center">Orawa Dzieciom Afryki</h3>-->
	<a href="#" class="button card__button">Dowiedz się więcej</a>
</div>
<div class="card grid__1-1 grid__1-2--sm grid__1-3--md">
	<div class="card__imageWrapper">
		<img class="card__image lazy loaded" alt="Orawa Dzieciom Afryki" data-ll-status="loaded" src="/wp-content/themes/nswm/assets/test/orawa.jpg">
	</div>
	<!--<h3 class="card__title text--center">Orawa Dzieciom Afryki</h3>-->
	<a href="#" class="button card__button">Dowiedz się więcej</a>
</div>
    `;



    const resultsContainer = document.getElementById("actionsResults");
    const placeholder = document.getElementById("actionsPlaceholder");


    const handleCategorySelectFn = function (categoryName, pageNumber) {

        const resultsFragment = document.createElement("template");
        resultsFragment.innerHTML = sampleResults;
        resultsContainer.appendChild(resultsFragment.content);
        return true;
    }

    const categorySelect = new CategorySelect({
        resultsContainer: resultsContainer,
        placeholder: placeholder,
        handleCategorySelectFn: handleCategorySelectFn
    });

})();